const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;

export const formatRelativeTime = (date: Date, locale: string): string => {
    const diff = date.getTime() - Date.now();
    const absoluteDiff = Math.abs(diff);
    const formatter = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });

    if (absoluteDiff < MINUTE) {
        return formatter.format(Math.round(diff / SECOND), "second");
    }

    if (absoluteDiff < HOUR) {
        return formatter.format(Math.round(diff / MINUTE), "minute");
    }

    if (absoluteDiff < DAY) {
        return formatter.format(Math.round(diff / HOUR), "hour");
    }

    if (absoluteDiff < MONTH) {
        return formatter.format(Math.round(diff / DAY), "day");
    }

    if (absoluteDiff < YEAR) {
        return formatter.format(Math.round(diff / MONTH), "month");
    }

    return formatter.format(Math.round(diff / YEAR), "year");
};
